// app/javascript/controllers/driving_school_payment_method_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "transactionSelect",
        "regularButton",
        "paymentButton",
        "notesField",
        "collectTaxGroup",
        "manualSalesTaxGroup"
    ];

    connect() {
        console.log("Payment method controller connected")
        this.handleTransactionTypeChange()
    }

    handleTakePaymentClick(event) {
        // no-op – reserved for future validation
    }

    handleTransactionTypeChange() {
        const selectedValue = this.transactionSelectTarget.value
        const form = this.element

        if (selectedValue === 'online_payment') {
            this.regularButtonTarget.style.display = 'none'
            this.paymentButtonTarget.style.display = 'inline-block'

            if (this.hasCollectTaxGroupTarget) {
                this.collectTaxGroupTarget.style.display = 'block'
            }
            if (this.hasManualSalesTaxGroupTarget) {
                this.manualSalesTaxGroupTarget.style.display = 'none'
            }

            // Full page submit so Stripe redirect works
            form.removeAttribute('data-turbo')
            form.removeAttribute('data-turbo-frame')
            form.setAttribute('data-turbo', 'false')

            console.log('Switched to online payment mode')
        } else {
            this.regularButtonTarget.style.display = 'inline-block'
            this.paymentButtonTarget.style.display = 'none'

            if (this.hasCollectTaxGroupTarget) {
                this.collectTaxGroupTarget.style.display = 'none'
            }
            if (this.hasManualSalesTaxGroupTarget) {
                this.manualSalesTaxGroupTarget.style.display = 'block'
            }

            form.setAttribute('data-turbo', 'true')

            console.log('Switched to regular payment mode')
        }
    }
}
